import { request } from 'src/api/request';

export const getOpenPaymentsSuggestionsV2 = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/open-payments-companies/${queryParams}`,
    method: 'GET',
  });
};
